export const Individual = 'Individual/';

export const SummarySearchIndividuals = Individual + 'SummarySearchIndividuals';
export const PeopleSearch = Individual + 'PeopleSearch'
export const SummarySearchIndividualsSalary = Individual + 'SummarySearchIndividualsSalary';
export const SaveIndividual = Individual + 'SaveIndividual';
export const GetIndividualByID = Individual + 'GetById';
export const DeleteIndividual = Individual + 'DeleteIndividual';
export const SearchIndividualsByIdNumberAndEmployeeCode = Individual + 'SearchIndividualsByIdNumberAndEmployeeCode';

export const IndividualEmployeeData = 'IndividualEmployeeData/';
export const SearchIndividualEmployeeData = IndividualEmployeeData + 'Search';
export const GetIndividualEmployeeDataById = IndividualEmployeeData + 'GetById';
export const SaveIndividualEmployeeData = IndividualEmployeeData + 'Save';
export const DeleteIndividualEmployeeData = IndividualEmployeeData + 'Delete';

// Core - When apis have been fully moved over. Remove all the old API mappings
export const IndividualBasicSearch = Individual + 'BasicSearch'
export const IndividualSearch = Individual + 'Search'
export const IndividualSalarySearch = Individual + 'SearchSalaries'
export const GetIndividuals = Individual
export const GetLatestPositionForIndividual = Individual + 'GetIndividualPosition/'